import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export const meGetGamificationAccounts = createQueryFn(
  QueryNameSpace.meGetGamificationAccounts,
  async () => {
    const res = await CoreApi.meGetGamificationAccounts();

    return res.accounts;
  },
);
